module.exports = __webpack_public_path__ + "img/12.cb716280.jpg";